module.exports = __webpack_public_path__ + "static/media/organizer_14.5f53c7be.jpg";